<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uZxrj5/tc-custom/9781466842212.jpg?1732131195096" alt="This image is the cover for the book Every Time You Go Away"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Every Time You Go Away
      </h1>
      <p class="bookDescription body article font2">
        <b>“A heartwarming story” about a fractured family’s reunion at their summer home blending “wry humor, heartfelt introspection, and, an unexpected romance” (<i>Booklist</i>).</b><br/><br/>Willa has never fully recovered from the sudden death of her husband, Ben. She became an absent mother to her young son, Jamie, unable to comfort him while reeling from her own grief.<br/><br/>Now, years after Ben’s death, Willa finally decides to return to the beach house where he passed. It’s time to move on and put the Ocean City, Maryland house on the market.<br/><br/>When Willa arrives, the house is in worse shape than she could have imagined, and the memories of her time with Ben are overwhelming. They met at this house and she sees him around every corner. Literally. Ben’s ghost keeps reappearing, trying to start conversations with Willa. And she can’t help talking back.<br/><br/>To protect her sanity, Willa enlists her son Jamie, her best friend Kristin, and Kristin’s daughter Kelsey to join her for one last summer at the beach. As they explore their old haunts, buried feelings come to the surface, Jamie and Kelsey rekindle their childhood friendship, and Willa searches for the chance to finally say goodbye to her husband and to reconnect with her son.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth Harbison
      </h2>
      
      <p class="authorDescription body article">BETH HARBISON is <I>The New York Times </I>bestselling author of <I>One Less Problem Without You;</I><I>If I Could Turn Back Time;</I><I>Driving with the Top Down;</I><I>Chose the Wrong Guy, Gave Him the Wrong Finger; When In Doubt, Add Butter; Always Something There To Remind Me; Thin, Rich, Pretty; Hope In A Jar; Secrets of a Shoe Addict; </I>and<I>Shoe Addicts Anonymous</I>. She grew up in Potomac, Maryland, outside Washington, DC, and now shares her time between that suburb, New York City, and a quiet home on the eastern shore.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21dd29be